module.exports = __webpack_public_path__ + "img/ORLOV.3a2cf3a7.png";